<app-rhero-shell></app-rhero-shell>

<!-- Vertical layout -->
@if(isVerticalLayoutRequested()){
<app-vertical></app-vertical>
}

<!-- Horizontal layout -->
@if(isHorizontalLayoutRequested()){
<app-horizontal></app-horizontal>
}
<!-- Two Columns layout -->
@if(isTwoColumnLayoutRequested()){
<app-two-column></app-two-column>
}
<!-- Semibox layout -->
@if(isSemiboxLayoutRequested()){
<app-vertical></app-vertical>}

<!-- Spec #1 — Incoming Call popup, mounted at the shell so it fires from any
     dispatcher page when the INCOMING_CALL socket event arrives. -->
<app-incoming-call-modal></app-incoming-call-modal>

<!-- Spec #1 — Floating queue of incoming calls that arrived while another
     call was being handled. Self-hides when empty. -->
<app-queued-calls-widget></app-queued-calls-widget>
